import { LISTING_PROFILE_DEFAULT_WIDGET_LIST_ORDER } from './RentalPortalListingProfileWidgetList.constants'
import { useListingProfileWidgets } from './RentalPortalListingProfileWidgetList.hooks'
import { getListingProfileOrderedWidgets } from './RentalPortalListingProfileWidgetList.utils'

function RentalPortalListingProfileWidgetList() {
  const { widgets } = useListingProfileWidgets()

  // TODO: re-enable `useWidgetListOrder` once the backend declares the `listing-detail` page key, which answers 400 today
  return getListingProfileOrderedWidgets({
    widgetListOrder: LISTING_PROFILE_DEFAULT_WIDGET_LIST_ORDER,
    widgets,
  })
}

export default RentalPortalListingProfileWidgetList
